/**
 * Data Compare Engine Utilities
 *
 * Utility functions for working with database engines in data compare.
 */

import type { DatabaseEngineId } from '../../../../core/engines';
import type { ActiveConnection } from '../../../connections/models/connectionTypes';

/**
 * Get engine ID from a connection ID
 * Checks both saved connections and active connections (for browser mode support)
 */
export function getEngineFromConnectionId(
  connectionId: string | undefined,
  connections: Array<{ id: string; engine?: string }>,
  activeConnections?: ActiveConnection[]
): DatabaseEngineId | undefined {
  if (!connectionId) return undefined;

  // Check saved connections first
  const savedConn = connections.find((c) => c.id === connectionId);
  if (savedConn) {
    const engine = savedConn.engine ?? 'mssql';
    if (engine === 'mssql' || engine === 'pgsql' || engine === 'mysql' || engine === 'sqlite' || engine === 'oracle' || engine === 'mock') {
      return engine;
    }
    return 'mssql';
  }

  // Fallback to active connections (for browser mode SQLite connections)
  if (activeConnections) {
    const activeConn = activeConnections.find((c) => c.id === connectionId);
    if (activeConn) {
      const engine = activeConn.connection.engine ?? 'mssql';
      if (engine === 'mssql' || engine === 'pgsql' || engine === 'mysql' || engine === 'sqlite' || engine === 'oracle' || engine === 'mock') {
        return engine;
      }
      return 'mssql';
    }
  }

  return undefined;
}
